import { render } from "./RadioTypeComponent.vue?vue&type=template&id=cf44398e&scoped=true"
import script from "./RadioTypeComponent.vue?vue&type=script&lang=js"
export * from "./RadioTypeComponent.vue?vue&type=script&lang=js"

import "./RadioTypeComponent.vue?vue&type=style&index=0&id=cf44398e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf44398e"]])

export default __exports__